<template>
    <template-block
        v-if="localModel"
        type="Sektion"
        @toggle-collapsible="$emit('toggle-collapsible')"
        :open="open"
        @delete="$emit('delete')"
        :locked="value.locked"
        :position="value.position"
        :mode="mode"
        @update:locked="localModel.locked = $event; emitChange();"
        @update:position="localModel.position = $event; emitChange();"
    >
        <div v-if="this.mode !== 'simple'" class="block-content-grid">
            <color-picker
                :vid="vid + '.backgroundColor'"
                label="Bakgrundsfärg"
                v-model="localModel.backgroundColor"
                @input="emitChange"
            ></color-picker>
            <input-with-validation
                label="Hörnradie"
                :vid="vid + '.borderRadius'"
                v-model="localModel.borderRadius"
                @input="emitChange"
                placeholder="Hörnradie"
            >
                <template v-slot:input-group-append>
                    <span class="input-group-text">px</span>
                </template>
            </input-with-validation>
            <input-with-validation
                label="Luft över"
                :vid="vid + '.paddingTop'"
                v-model="localModel.paddingTop"
                @input="emitChange"
                placeholder="Luft över"
            >
                <template v-slot:input-group-append>
                    <span class="input-group-text">px</span>
                </template>
            </input-with-validation>
            <input-with-validation
                label="Luft under"
                :vid="vid + '.paddingBottom'"
                v-model="localModel.paddingBottom"
                @input="emitChange"
                placeholder="Luft under"
            >
                <template v-slot:input-group-append>
                    <span class="input-group-text">px</span>
                </template>
            </input-with-validation>
            <input-with-validation
                label="Luft vänster"
                :vid="vid + '.paddingLeft'"
                v-model="localModel.paddingLeft"
                @input="emitChange"
                placeholder="Luft vänster"
            >
                <template v-slot:input-group-append>
                    <span class="input-group-text">px</span>
                </template>
            </input-with-validation>
            <input-with-validation
                label="Luft vänster"
                :vid="vid + '.paddingRight'"
                v-model="localModel.paddingRight"
                @input="emitChange"
                placeholder="Luft vänster"
            >
                <template v-slot:input-group-append>
                    <span class="input-group-text">px</span>
                </template>
            </input-with-validation>
        </div>
        <draggable
            v-model="localModel.blocks"
            group="base"
            handle=".handle"
            class="ecard-template-blocks mb-3"
            @sort="onSort"
        >
            <component
                v-for="(block, b_index) in localModel.blocks"
                :key="'b-' + block.id"
                :vid="vid + '.blocks.' + b_index"
                v-model="localModel.blocks[b_index]"
                :is="'block-' + block.type"
                :open="collapsible_state[block.id]"
                @toggle-collapsible="toggleCollapsible(block.id)"
                @delete="deleteBlock(block.id)"
                @input="emitChange"
                :mode="mode"
            ></component>
        </draggable>
        <div class="btn-group justify-content-center">
            <a href="#" class="btn btn-light dropdown-toggle" data-toggle="dropdown">Add content</a>

            <div class="dropdown-menu">
                <a href="#" @click.prevent="addBlock('text')" class="dropdown-item">Text</a>
                <a href="#" @click.prevent="addBlock('image')" class="dropdown-item">Bild</a>
                <a href="#" @click.prevent="addBlock('redeem')" class="dropdown-item">Redeem</a>
                <a href="#" @click.prevent="addBlock('button')" class="dropdown-item">Knapp</a>
                <a href="#" @click.prevent="addBlock('divider')" class="dropdown-item">Avdelare</a>
                <a href="#" @click.prevent="addBlock('spacer')" class="dropdown-item">Mellanrum</a>
                <a href="#" @click.prevent="addBlock('greeting')" class="dropdown-item">Hälsning</a>
                <!--                                <a href="#" @click.prevent="addBlock('header')" class="dropdown-item">Header</a>-->
                <!--                                <a href="#" @click.prevent="addBlock('footer')" class="dropdown-item">Footer</a>-->
            </div>
        </div>
    </template-block>
</template>

<script>
import draggable from 'vuedraggable';
import TemplateBlock from '@components/Ecard/TemplateBlock.vue';
import BlockButton from '@components/Ecard/BlockButton.vue';
import BlockDivider from '@components/Ecard/BlockDivider.vue';
import BlockFooter from '@components/Ecard/BlockFooter.vue';
import BlockHeader from '@components/Ecard/BlockHeader.vue';
import BlockImage from '@components/Ecard/BlockImage.vue';
import BlockRedeem from '@components/Ecard/BlockRedeem.vue';
import BlockText from '@components/Ecard/BlockText.vue';
import BlockGreeting from '@components/Ecard/BlockGreeting.vue';
import { genUUID } from '@services/Helpers';
import InputWithValidation from '@components/Form/InputWithValidation.vue';
import ColorPicker from '@components/Form/ColorPicker.vue';
import {
    sortBlocks,
} from '@services/EcardTemplateHelpers';

export default {
    name: 'BlockSection',
    components: {
        draggable,
        ColorPicker,
        InputWithValidation,
        TemplateBlock,
        BlockButton,
        BlockDivider,
        BlockFooter,
        BlockHeader,
        BlockImage,
        BlockRedeem,
        BlockText,
        BlockGreeting,
    },
    props: {
        value: {
            type: Object,
            required: true,
        },
        vid: {
            type: String,
            default: 'section.',
        },
        open: {
            type: Boolean,
            default: false,
        },
        mode: {
            type: String,
            default: 'normal',
        },
    },
    data: () => ({
        collapsible_state: {},
        localModel: null,
    }),
    mounted() {
        this.init(this.value);
    },
    watch: {
        value: {
            deep: true,
            handler(newVal) {
                this.init(newVal);
            },
        },
    },
    methods: {
        init(newVal) {
            let newBlocks = [];
            if (Array.isArray(newVal.blocks)) {
                const state = {};
                newBlocks = JSON.parse(JSON.stringify(newVal.blocks));
                newBlocks.forEach((b) => {
                    if (!Object.hasOwn(this.collapsible_state, b.id)) {
                        state[b.id] = false;
                    } else {
                        state[b.id] = this.collapsible_state[b.id];
                    }
                });
                this.collapsible_state = state;
            }

            this.localModel = {
                type: 'section',
                id: newVal.id || genUUID(),
                backgroundColor: newVal.backgroundColor || '#FFFFFF',
                paddingTop: newVal.paddingTop ?? 10,
                paddingBottom: newVal.paddingBottom ?? 10,
                paddingLeft: newVal.paddingLeft ?? 20,
                paddingRight: newVal.paddingRight ?? 20,
                borderRadius: newVal.borderRadius ?? 0,
                blocks: newBlocks,
                locked: newVal.locked === undefined || newVal.locked === null ? false : newVal.locked,
            };
        },
        toggleCollapsible(blockId) {
            if (!Object.hasOwn(this.collapsible_state, blockId)) {
                this.collapsible_state[blockId] = false;
            }
            this.collapsible_state[blockId] = !this.collapsible_state[blockId];
        },
        addBlock(type) {
            this.localModel.blocks.push({
                id: genUUID(),
                type,
            });
            this.onSort();
        },
        deleteBlock(blockId) {
            const index = this.localModel.blocks.findIndex((b) => b.id === blockId);
            if (index > -1) {
                this.localModel.blocks.splice(index, 1);
                this.emitChange();
            }
        },
        onSort() {
            this.localModel.blocks = sortBlocks(this.localModel.blocks);
            this.emitChange();
        },
        emitChange() {
            this.$emit('input', { ...this.localModel });
        },
    },
};
</script>

<style scoped>
.sortable-ghost {
    border: 1px dashed #aaa;
    position:relative;
    box-shadow: none;
    -webkit-box-shadow: none;
}
.sortable-ghost:before {
    content: '';
    position: absolute;
    display: block;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background-color: #ffffff;
    z-index: 10;
    padding: 20px;
}
</style>
